import {
  CALC_FILL,
  TABLE_HEADER_FILL,
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  COL_H,
  COL_I,
  COL_J,
  COL_K,
  COL_L,
  COL_M,
  COL_N,
  COL_LABEL_END,
  COL_VALUE_START,
  COL_VALUE_END,
  addShortAnswerRow,
  addTextAnswerRow,
  formatNumber,
  mergeRow,
  safeText,
  setCell,
  toYesNo,
} from "./principle5SheetHelpers.js";
import { getFinancialYearLabels } from "../../brsrFinancialYearLabels.js";

export {
  CALC_FILL,
  SUBHEADER_FILL,
  TABLE_HEADER_FILL,
  HEADER_FILL,
  LINKED_FILL,
  NA_FILL,
  TITLE_FONT,
  VALUE_FILL,
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  COL_H,
  COL_I,
  COL_J,
  COL_K,
  COL_L,
  COL_M,
  COL_N,
  COL_END,
  COL_LABEL_END,
  COL_VALUE_START,
  COL_VALUE_END,
  addQuestionRow,
  addSectionHeader,
  addShortAnswerRow,
  addTextAnswerRow,
  borderFromSpecs,
  formatNumber,
  formatPercent,
  getFyLabels,
  mergeRow,
  padMergeRow,
  parseBorderSpec,
  safeText,
  setCell,
  setGrey,
  setLinked,
  setPlain,
  setPrinciple5ColumnWidths,
  setWhite,
  toYesNo,
  toYesNoNa,
} from "./principle5SheetHelpers.js";

export const COL_PARAM_END = COL_G;
export const COL_UNIT = COL_H;
export const COL_FY_START = COL_I;
export const COL_FY_END = COL_K;
export const COL_PY_START = COL_L;
export const COL_PY_END = COL_N;

export function readFY(cell, which = "current") {
  if (!cell || typeof cell !== "object") return "";
  if (which === "current") {
    return cell.currentFinancialYear ?? cell.currentFinacialYear ?? "";
  }
  return cell.previousFinancialYear ?? cell.previousFinacialYear ?? "";
}

export function toNum(value) {
  const n = Number(String(value ?? "").replace(/,/g, ""));
  return Number.isFinite(n) ? n : null;
}

export function sumFYCells(obj, keys, which) {
  let sum = 0;
  let any = false;
  keys.forEach((key) => {
    const n = toNum(readFY(obj?.[key], which));
    if (n !== null) {
      sum += n;
      any = true;
    }
  });
  return any ? sum : null;
}

export function formatDischarge(value) {
  if (value === null || value === undefined || value === "") return "-";
  return formatNumber(value);
}

export function sumDischargeSources(root, keys) {
  let sum = 0;
  let any = false;
  keys.forEach((key) => {
    const o = root?.[key] || {};
    const t1 = toNum(o.dischargeWithoutTreatment);
    const t2 = toNum(o.dischargeAfterTreatment);
    if (t1 !== null) {
      sum += t1;
      any = true;
    }
    if (t2 !== null) {
      sum += t2;
      any = true;
    }
  });
  return any ? sum : null;
}

export function formatUnit(unit, fallback = "-") {
  if (!unit) return fallback;
  const map = {
    GJ: "Gigajoule (GJ)",
    MJ: "Megajoule (MJ)",
    TJ: "Terajoule (TJ)",
    "MtCO2e": "MtCO2e",
    "MtCO2e / Rs.": "MtCO2e / Rs.",
    "ug/m3": "ug/m3",
    "Parts Per Million (PPM)": "Parts Per Million (PPM)",
    Rs: "Rs.",
  };
  return map[unit] || String(unit);
}

export function externalAgencyText(agency) {
  const answer = toYesNo(agency?.action);
  if (answer !== "Yes") return answer;
  const name = Array.isArray(agency?.name)
    ? agency.name.filter(Boolean).join(", ")
    : agency?.name;
  return safeText(name);
}

export function hasEnergyData(energy) {
  const sources = [
    energy?.fromRenewableSource,
    energy?.fromNonRenewableSource,
    energy?.energyIntensity,
  ];
  return sources.some((src) =>
    Object.values(src || {}).some((cell) => {
      const c = readFY(cell, "current");
      const p = readFY(cell, "previous");
      return String(c).trim() !== "" || String(p).trim() !== "";
    })
  );
}

export function addParamUnitFyHeader(ws, row, fyCurrent, fyPrevious, unitLabel = "Unit") {
  mergeRow(ws, row, COL_D, COL_PARAM_END, "Parameter", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });
  setCell(ws, row, COL_UNIT, unitLabel, { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  mergeRow(ws, row, COL_FY_START, COL_FY_END, fyCurrent, {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });
  mergeRow(ws, row, COL_PY_START, COL_PY_END, fyPrevious, {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });
  return row + 1;
}

export function addParamUnitFyRow(ws, row, label, unit, curr, prev, options = {}) {
  mergeRow(ws, row, COL_D, COL_PARAM_END, label, {
    align: "left",
    fill: options.fill,
    bold: options.bold,
  });
  setCell(ws, row, COL_UNIT, unit ?? "-", { align: "center", fill: options.fill });
  mergeRow(ws, row, COL_FY_START, COL_FY_END, formatNumber(curr), {
    align: "center",
    fill: options.fill,
  });
  mergeRow(ws, row, COL_PY_START, COL_PY_END, formatNumber(prev), {
    align: "center",
    fill: options.fill,
  });
  return row + 1;
}

export function addParamFyHeader(ws, row, fyCurrent, fyPrevious) {
  mergeRow(ws, row, COL_D, COL_LABEL_END, "Parameter", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });
  mergeRow(ws, row, COL_FY_START, COL_FY_END, fyCurrent, {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });
  mergeRow(ws, row, COL_PY_START, COL_PY_END, fyPrevious, {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });
  return row + 1;
}

export function addParamFyRow(ws, row, label, curr, prev, options = {}) {
  mergeRow(ws, row, COL_D, COL_LABEL_END, label, {
    align: "left",
    fill: options.fill,
    bold: options.bold,
  });
  mergeRow(ws, row, COL_FY_START, COL_FY_END, formatNumber(curr), {
    align: "center",
    fill: options.fill,
  });
  mergeRow(ws, row, COL_PY_START, COL_PY_END, formatNumber(prev), {
    align: "center",
    fill: options.fill,
  });
  return row + 1;
}

export function readAgencyNames(agency) {
  if (!agency || typeof agency !== "object") return "";
  const names = agency.name;
  if (Array.isArray(names)) {
    const filtered = names.map((n) => String(n ?? "").trim()).filter(Boolean);
    if (filtered.length) return filtered.join(", ");
  } else if (names !== null && names !== undefined && String(names).trim()) {
    return String(names).trim();
  }
  for (const key of ["agencyName", "externalAgency", "remark"]) {
    const value = agency[key];
    if (value !== null && value !== undefined && String(value).trim()) {
      return String(value).trim();
    }
  }
  return "";
}

export function getReportFyLabels(reportingYear = "") {
  const fy = getFinancialYearLabels(reportingYear);
  return {
    current: fy.currentYear
      ? `In FY ${fy.currentYear} (Current Financial Year)`
      : "In FY (Current Financial Year)",
    previous: fy.previousYear
      ? `In FY ${fy.previousYear} (Previous Financial Year)`
      : "In FY (Previous Financial Year)",
  };
}

export function addCategoryFyHeader(ws, row, fyCurrent, fyPrevious) {
  mergeRow(ws, row, COL_D, COL_LABEL_END, "Category", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });
  mergeRow(ws, row, COL_FY_START, COL_FY_END, fyCurrent, {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });
  mergeRow(ws, row, COL_PY_START, COL_PY_END, fyPrevious, {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });
  return row + 1;
}

export function formatInlineAgencyAnswer(agency) {
  const answer = toYesNo(agency?.action);
  if (answer !== "Yes") return answer;
  const name = readAgencyNames(agency);
  return name ? `Yes, ${name}` : "Yes";
}

export function addInlineExternalAgencyRow(ws, row, agency) {
  return addTextAnswerRow(
    ws,
    row,
    "If any independent assessment/ evaluation/assurance has been carried out by an external agency? (Yes / No)",
    formatInlineAgencyAnswer(agency)
  );
}

export function addExternalAgencyRows(ws, row, agency) {
  row = addShortAnswerRow(
    ws,
    row,
    "Note: Indicate if any independent assessment/ evaluation/assurance has been carried out by an external agency? (Y/N)",
    toYesNo(agency?.action)
  );
  row = addTextAnswerRow(
    ws,
    row,
    "If yes, name of the external agency.",
    toYesNo(agency?.action) === "Yes" ? readAgencyNames(agency) : ""
  );
  return row;
}

export function excelWorksheetName(name) {
  return String(name).substring(0, 31);
}

export function internalSheetLink(sheetName, cell = "D3") {
  const tabName = excelWorksheetName(sheetName).replace(/'/g, "''");
  return `#'${tabName}'!${cell}`;
}

export function addShowDetailLink(ws, row, label, sheetName) {
  mergeRow(ws, row, COL_D, COL_LABEL_END, label, { align: "left", vertical: "top" });
  mergeRow(ws, row, COL_VALUE_START, COL_N, "Show Detail", {
    align: "center",
    vertical: "middle",
    link: internalSheetLink(sheetName),
  });
  return row + 1;
}

export function normalizeEnergyDetailRows(source) {
  if (!source) return [];
  const list = Array.isArray(source) ? source : Array.isArray(source?.list) ? source.list : [];
  return list
    .map((item) => ({
      source: item?.source ?? item?.sourceOfEnergy ?? item?.name ?? item?.parameter ?? "",
      unit: item?.unit ?? item?.currentUnit ?? "",
      current: readFY(item, "current"),
      previous: readFY(item, "previous"),
    }))
    .filter((item) => item.source || item.current || item.previous);
}

export function getEnergyDetailRows(energy, renewable = true) {
  const prefix = renewable ? "Renewable" : "NR";
  const candidates = [
    energy?.[`energyConsumedFrom${prefix}`],
    energy?.[`energyConsumedFrom${renewable ? "Renewable" : "NonRenewable"}Source`],
    energy?.[`${renewable ? "fromRenewable" : "fromNonRenewable"}Details`],
  ];
  for (const candidate of candidates) {
    const rows = normalizeEnergyDetailRows(candidate);
    if (rows.length) return rows;
  }
  return [];
}

export function calcEnergyTotal(source, keys) {
  const curr = sumFYCells(source, keys, "current");
  const prev = sumFYCells(source, keys, "previous");
  return { current: curr, previous: prev };
}

export { CALC_FILL as TOTAL_FILL };

/** PRINCIPLE 6 main sheet column layout (reference XBRL format.xlsx). */
export function setPrinciple6ColumnWidths(ws) {
  const widths = {
    A: 12.1796875,
    B: 12.1796875,
    C: 9.1796875,
    D: 50.81640625,
    E: 30.7265625,
    F: 30.7265625,
    G: 30,
    H: 15.7265625,
    I: 13.1796875,
    J: 13.1796875,
    K: 13.1796875,
    L: 30.7265625,
    M: 30.7265625,
    N: 30.7265625,
  };
  Object.entries(widths).forEach(([col, width]) => {
    ws.getColumn(col).width = width;
  });
  ["A", "B"].forEach((col) => {
    ws.getColumn(col).hidden = true;
  });
  for (let col = 12; col <= 16384; col += 1) {
    ws.getColumn(col).hidden = true;
  }
}

export function setupPrinciple6SheetView(workbook, ws) {
  ws.views = [
    {
      showGridLines: false,
      state: "frozen",
      xSplit: 0,
      ySplit: 6,
      topLeftCell: "D8",
      zoomScale: 70,
      zoomScaleNormal: 70,
    },
  ];
  if (!workbook.views?.length) {
    workbook.views = [{ showGridLines: false }];
  } else {
    workbook.views[0].showGridLines = false;
  }
}
